import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom';
import DropDown from '../CommonControlls/DropdownRendrer'
import { SelectAllRoles, SelectAllDistricts, SelectAllProvince, SelectAllTehsils } from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal';
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import jsPDF from "jspdf";


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => { dispatch({ type: "UpdateAlert", payload: Settings }) },
        ShowLoader: (Isloading) => { dispatch({ type: "UpdateLoader", payload: Isloading }) },
    }
}

class AssignedDFS_Riders extends Component {

    constructor(props) {
        super(props);
        this.state = {

            loggedinUser: 0,

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,
            exportLoading: false,

            permissions: [],

            sortField: "id",
            idsortOrder: "desc",
            provinceNamesortOrder: "",
            districtNamesortOrder: "",
            tehsilNamesortOrder: "",
            roleNamesortOrder: "",
            appVersionsortOrder: "",


            //Roles
            RolesLoader: false,
            Roleslist: [],
            RoleId: 0,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: [],

            loadingExport: false,

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: [],

            TehsilLoader: false,
            Tehsillist: [],
            FilteredTehsillist: [],
            TehsilId: [],

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({
            [fieldId]: value,
            // isSaveSearch: this.state.isSearchChanged ? true : false
        }, () => {
            if (fieldId === "ProvinceId") {
                this.FilterDistricts(value)
            }
            if (fieldId === "DistrictId") {
                this.FilterTehsils(value)
            }
        })
    }
    FilterDistricts = (value) => {

        // filter ditrict list
        var TempArr = this.state.Districtlist
        var selectedProvince = Common.ConvertToCommaSplitArray(value, "id")
        var filteredDistrictList = TempArr.filter(function (obj) {
            return selectedProvince.indexOf(obj.provinceId) > -1
        });

        // filter district selected values
        var selectedDistricts = this.state.DistrictId
        var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(filteredDistrictList, "id")
        var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
            return filteredDistrictIdArr.indexOf(obj.id) > -1
        });

        this.setState({
            FilteredDistrictlist: filteredDistrictList,
            DistrictId: filteredSelectedDistricts
        })
    }
    FilterTehsils = (value) => {

        // filter Tehsil list
        var TempArr = this.state.Tehsillist
        var selectedVale = Common.ConvertToCommaSplitArray(value, "id")
        var filteredTehsilList = TempArr.filter(function (obj) {
            return selectedVale.indexOf(obj.districtId) > -1
        });

        // filter Tehsil selected values
        var selectedTehsils = this.state.TehsilId
        var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(filteredTehsilList, "id")
        var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
            return filteredTehsilIdArr.indexOf(obj.id) > -1
        });

        this.setState({
            FilteredTehsillist: filteredTehsilList,
            TehsilId: filteredSelectedTehsils
        })
    }

    render() {

        const CellMenu = (cell, row) => {
            return (
                <div>
                    <Link hidden={this.state.loggedinUser === row.id} to={"/User_Edit/" + row.id}><button data-toggle="tooltip" title="Edit" class="btn TableRow_btn"><i class="fa fa-pencil-square-o text-primary" aria-hidden="true"></i></button></Link>
                    <button hidden={this.state.loggedinUser === row.id} onClick={(() => this.onDelete(row.id, row.role))} data-toggle="tooltip" title="Delete" class="btn text-red TableRow_btn"><i class="fa fa-trash-o text-danger" aria-hidden="true"></i></button>
                </div>
            )
        }

        // function avatarformatter(cell, row) {
        //     return (
        //         <span style={{ display: "flex" }}>
        //             <span style={{ flex: "1", maxWidth: "45px", minWidth: "45px", position: "relative", bottom: "-5px" }}>
        //                 <img class="user-avatar rounded-circle" style={{ border: "1px solid #ced4da" }} height="37px" width="37px" src={row.imageURLBase64 == "" || row.imageURLBase64 == null ? UserLogo_Tablelist : row.imageURLBase64} />
        //             </span>
        //             <span>
        //                 {row.name}<br />
        //                 <span>{row.contact}</span>
        //             </span>

        //         </span>
        //     );
        // }

        const UserTypeformatter = (cell, row) => {
            return (
                <div className="UserType_Span">
                    {cell}
                </div>
            )
        }

        const columns = [
            {
                dataField: 'provinceName',
                text: 'Province',
                sort: true,
                headerStyle: (colum, colIndex) => { return { width: '115px', fontSize: '13px' } },
            },
            {
                dataField: 'districtName',
                text: 'District',
                sort: true,
                headerStyle: (colum, colIndex) => { return { width: '115px', fontSize: '13px' } },
            },
            {
                dataField: 'short_name',
                text: 'Sr. Name',
                headerStyle: () => {
                    return {fontSize: '13px', width: '100px'}
                },
                sort: true,
            },
            {
                dataField: 'tehsilName',
                text: 'Tehsil',
                sort: true,
                headerStyle: (colum, colIndex) => { return { width: '115px', fontSize: '13px' } },
            },
            {
                dataField: 'name',
                text: 'User Name',
                // formatter: (cell, row) => { return avatarformatter(cell, row) },
                headerStyle: (colum, colIndex) => { return { width: '145px', fontSize: '13px' } },
            },
            {
                dataField: 'cnic',
                text: 'CNIC #',
                sort: true,
                headerStyle: (colum, colIndex) => { return { width: '100px', fontSize: '13px' } },
            },
            // {
            //     dataField: 'contact',
            //     text: 'Phone',
            //     sort: true,
            //     csvFormatter:contact => ( contact==null?"":contact ),
            // },
            {
                dataField: 'roleName',
                text: 'User Type',
                formatter: (cell, row) => { return UserTypeformatter(cell, row) },
                headerStyle: (colum, colIndex) => { return { width: '160px', fontSize: '13px' } },
                sort: true,
            },
            // {
            //     dataField: 'email',
            //     text: 'Email',
            //     headerStyle: (colum, colIndex) => {return { width: '220px' }},
            //     sort: true,
            // },
            {
                dataField: 'isActive',
                text: 'Status',
                headerStyle: (colum, colIndex) => { return { width: '70px', fontSize: '13px' } },
                formatter: (cell, row) => { return <span>{cell ? "Active" : "InActive"}</span> },
                csvFormatter: isActive => (isActive ? "Active" : "InActive"),
                // sort: true,
            }, {
                dataField: 'appVersion',
                text: 'App Version',
                headerStyle: (colum, colIndex) => { return { width: '110px', fontSize: '13px' } },
                // sort: true,
            }, {
                dataField: '',
                text: 'Actions',
                headerStyle: (colum, colIndex) => { return { width: '100px', fontSize: '13px' } },
                formatter: (cell, row) => { return CellMenu(cell, row) },
                csvExport: false
            }
        ];

        return (

            <div>
                <MainLayout />
                <AlertModal  {...this.state.alertModalData} />
                <div id="right-panel" class="right-panel">
                    {/* this.state.permissions.includes('users-add') */}
                    <Topmenu PageTitle="Assigned DFS Riders" isShowAddBtn={false} AddBtnLabel="Add User" AddBtnLink="/User_Add" />
                    <div class="content">

                        {/* <div class="PageHeader_Container">
                                <h2 class="Pageheading">Users</h2>
                                <div class="PageMenu_Container"><Link to="/User_Add"><button class="btn btn_style2">Add User</button></Link></div>
                            </div> */}

                        {/*<div class="card" style={{ marginBottom: "20px", background: "none", boxShadow: "none" }}>*/}
                        {/*    <div class="card-body row" style={{ padding: "0px" }}>*/}
                        {/*        <div class="widget-tabs-list">*/}
                        {/*            <ul class="Cases-nav nav nav-tabs">*/}
                        {/*                <li><Link data-toggle="tab" to="/Users" class="active show">Users</Link></li>*/}
                        {/*                <li><Link data-toggle="tab" to="/User_Requests">Requests</Link></li>*/}
                        {/*            </ul>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div class="card">
                            <div class="card-body">
                                {/*<div class="Table_Search row">*/}
                                {/*    <div class="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <label for="">Province</label>*/}
                                {/*        <DropDown*/}
                                {/*            multi={true}*/}
                                {/*            dropdownRenderer={true}*/}
                                {/*            create={false}*/}
                                {/*            onChange={this.HandleAutoSuggestValChange}*/}
                                {/*            Type="ProvinceId"*/}
                                {/*            options={this.state.Provincelist}*/}
                                {/*            val={this.state.ProvinceId}*/}
                                {/*            addPlaceholder=""*/}
                                {/*            disabled={false}*/}
                                {/*            loading={this.state.ProvinceLoader}*/}
                                {/*            searchBy="name"*/}
                                {/*            labelField="name"*/}
                                {/*            valueField="id"*/}
                                {/*            contentRenderer={true}*/}
                                {/*            placeholder="Select"*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                
                                {/*    <div class="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <label for="">District</label>*/}
                                {/*        <DropDown*/}
                                {/*            multi={true}*/}
                                {/*            dropdownRenderer={true}*/}
                                {/*            create={false}*/}
                                {/*            onChange={this.HandleAutoSuggestValChange}*/}
                                {/*            Type="DistrictId"*/}
                                {/*            options={this.state.FilteredDistrictlist}*/}
                                {/*            val={this.state.DistrictId}*/}
                                {/*            addPlaceholder=""*/}
                                {/*            disabled={false}*/}
                                {/*            loading={this.state.DistrictLoader}*/}
                                {/*            searchBy="name"*/}
                                {/*            labelField="name"*/}
                                {/*            valueField="id"*/}
                                {/*            contentRenderer={true}*/}
                                {/*            placeholder="Select"*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                
                                {/*    <div class="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <label for="">Tehsil</label>*/}
                                {/*        <DropDown*/}
                                {/*            multi={true}*/}
                                {/*            dropdownRenderer={true}*/}
                                {/*            create={false}*/}
                                {/*            onChange={this.HandleAutoSuggestValChange}*/}
                                {/*            Type="TehsilId"*/}
                                {/*            options={this.state.FilteredTehsillist}*/}
                                {/*            val={this.state.TehsilId}*/}
                                {/*            addPlaceholder=""*/}
                                {/*            disabled={false}*/}
                                {/*            loading={this.state.TehsilLoader}*/}
                                {/*            searchBy="name"*/}
                                {/*            labelField="name"*/}
                                {/*            valueField="id"*/}
                                {/*            contentRenderer={true}*/}
                                {/*            placeholder="Select"*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                
                                {/*    <div class="formInput_Container Search_InputSelectContainer col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <label for="">User Type</label>*/}
                                {/*        <DropDown*/}
                                {/*            multi={false}*/}
                                {/*            dropdownRenderer={false}*/}
                                {/*            create={false}*/}
                                {/*            onChange={this.HandleAutoSuggestValChange}*/}
                                {/*            Type="RoleId"*/}
                                {/*            options={this.state.Roleslist}*/}
                                {/*            val={this.state.RoleId}*/}
                                {/*            addPlaceholder=""*/}
                                {/*            disabled={false}*/}
                                {/*            loading={this.state.RolesLoader}*/}
                                {/*            searchBy="roleName"*/}
                                {/*            labelField="roleName"*/}
                                {/*            valueField="id"*/}
                                {/*            contentRenderer={false}*/}
                                {/*            placeholder="Select"*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                
                                {/*    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <label for="">User Name</label>*/}
                                {/*        <input autocomplete="off" type="text" class="form-control Search_InputField" id="SearchName" placeholder="Enter user name" />*/}
                                {/*    </div>*/}
                                
                                {/*    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <label for="">User Phone</label>*/}
                                {/*        <input autocomplete="off" pattern="[0][0-9]{10}" type="number" class="form-control Search_InputField" id="UserPhone" placeholder="Enter user phone" />*/}
                                {/*    </div>*/}
                                
                                {/*    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">*/}
                                {/*        <button onClick={() => { this.PopulateTable() }} style={{ position: "relative" }} id="FormSearchBtn" class="btn SearchTable_Btn">Search</button>*/}
                                {/*    </div>*/}
                                
                                {/*</div>*/}

                                {/* <div class="TableTop_Buttons">
                        <span onClick={() => { $(".react-bs-table-csv-btn").click()}} class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    exportPdf={this.ExportPdf}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.setState({
                                                exportLoading: true
                                            })
                                            this.ExportData(size)
                                        }, 100)
                                    }}
                                    exportAllowed={this.state.permissions.includes('users-export')}
                                    totalSize={this.state.TotalRecord}
                                    exportLoading={this.state.exportLoading}
                                    onTableChange={this.handleTableChange}
                                    isPagination={true}
                                    columns={columns}

                                    pdfExportLoading={this.state.loadingExport}
                                    loading={this.state.loading}
                                    RefreshTable={this.PopulateTable}
                                />

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }

        Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
            this.setState({
                loggedinUser: user.id
            })
        })
    }
    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_AssignedDFSRiders")
        this.GetPageConfigData(() => {
            this.PopulateTable()
        })
        $(".Search_InputField").on('keypress', (e) => {
            if (e.which === 13) {
                this.PopulateTable()
            }
        });
        this.SelectRoles()


        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_RolesPermissions, {}, (resp) => {
            const modifiedPermissions = resp.data.filter(p => p.permissioN_GROUP === 'Users' && p.permissioN_ALLOWED).map(d => d.permissioN_NAME)
            this.setState({ permissions: modifiedPermissions })
        })

    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true })
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        var d4 = $.Deferred();

        this.SelectProvinces(() => { d2.resolve() })
        this.SelectDistricts(() => { d3.resolve() })
        this.SelectTehsil(() => { d4.resolve() })

        $.when(d2, d3, d4).done(() => {
            this.props.ShowLoader({ Isloading: false })
            CallBack()
        });
    }

    SelectRoles = () => {
        this.setState({RolesLoader: true})

        var Parameters = {
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_Role, Parameters, (resp) => {
                this.setState({
                    Roleslist: resp.data,
                    RolesLoader: false
                })
            },
            () => {
                this.setState({RolesLoader: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again."})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }

    SelectProvinces = (Callback) => {
        this.setState({ProvinceLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Province, {}, (data) => {
            this.setState({
                ProvinceLoader: false,
                Provincelist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({ProvinceLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_District, {}, (data) => {
            this.setState({
                DistrictLoader: false,
                Districtlist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({ DistrictLoader: false })
            this.props.ShowAlert({ Type: 0, Msg: error })
            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            Callback()
        })
    }
    SelectTehsil = (Callback) => {
        this.setState({TehsilLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Tehsil, {}, (data) => {
            this.setState({
                TehsilLoader: false,
                Tehsillist: data.data
            })
            Callback()
        }, (error) => {
            this.setState({TehsilLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }

    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "sort") {
            let tempFieldorderLabel = sortField + "sortOrder"
            let tempFieldorder = this.state[tempFieldorderLabel] === "" ? sortOrder : this.state[tempFieldorderLabel] === "asc" ? "desc" : "asc"
            this.setState({
                sortField,
                [tempFieldorderLabel]: tempFieldorder
            }, () => {
                this.PopulateTable()
            })
            return
        }
        this.setState({
            page,
            sizePerPage
        }, () => { this.PopulateTable() })
    }

    ExportPdf = () => {
        const doc = new jsPDF()
        this.setState({loadingExport: true})


        var Parameters = {
            UserName: $("#SearchName").val(),
            UserPhone: $("#UserPhone").val(),
            RoleId: this.state.RoleId,
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
            provinceId: this.state.ProvinceId,
            districtId: this.state.DistrictId,
            tehsilId: this.state.TehsilId,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_Users, Parameters, (resp) => {
            $("#FormSearchBtn").prop('disabled', false);
            this.setState({ loading: false })
            if (resp.status) {
                doc.autoTable({
                    theme: 'grid',
                    body: [
                        ...resp.data
                    ],
                    columns: [
                        {header: 'id', dataKey: 'id'},
                        {header: 'Name', dataKey: 'name'},
                        {header: 'Email', dataKey: 'email'},
                        {header: 'Address', dataKey: 'address'},
                        {header: 'Contact', dataKey: 'contact'},
                        {header: 'Account #', dataKey: 'accountNumber'},
                        {header: 'SR Name', dataKey: 'short_name'},
                        {header: 'Role', dataKey: 'roleName'},
                        {header: 'Active', dataKey: 'isActive'},
                        {header: 'Bank', dataKey: 'bankName'},
                        {header: 'Province', dataKey: 'provinceName'},
                        {header: 'Tehsil', dataKey: 'tehsilName'},
                        {header: 'District', dataKey: 'districtName'},
                    ],
                })

                doc.save('users.pdf')
                this.setState({loadingExport: false})

            }
        })
    }

    ExportData = (size) => {
        var Parameters = {
            UserName: $("#SearchName").val(),
            UserPhone: $("#UserPhone").val(),
            RoleId: this.state.RoleId,
            pageSize: size,
            pageNumber: 1,
            provinceId: this.state.ProvinceId,
            districtId: this.state.DistrictId,
            tehsilId: this.state.TehsilId,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_Users, Parameters, (resp) => {
            $("#FormSearchBtn").prop('disabled', false);
            this.setState({ loading: false })
            if (resp.status) {
                this.setState({
                    data: resp.data,
                    TotalRecord: resp.totalRecord,
                    exportLoading: false
                })
                $(".react-bs-table-csv-btn").click()
                this.PopulateTable()
            }
        })
    }

    PopulateTable = () => {
        $("#FormSearchBtn").prop('disabled', true);
        this.setState({ loading: true, data: [], TotalRecord: 0 })
        // var provinceIdString = this.state.ProvinceId.length === 0 ? "" : ("," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",")
        // var districtIdString = this.state.DistrictId.length === 0 ? "" : ("," + Common.convertToCommaString(this.state.DistrictId, "id") + ",")
        // var tehsilIdString = this.state.TehsilId.length === 0 ? "" : ("," + Common.convertToCommaString(this.state.TehsilId, "id") + ",")
        //
        // const Parameters = {
        //     provinceIdString,
        //     districtIdString,
        //     tehsilIdString,
        //     UserName: $("#SearchName").val(),
        //     UserPhone: $("#UserPhone").val(),
        //     RoleId: this.state.RoleId,
        //     pageSize: this.state.sizePerPage,
        //     pageNumber: this.state.page,
        //     provinceId: this.state.ProvinceId,
        //     districtId: this.state.DistrictId,
        //     tehsilId: this.state.TehsilId,
        //     srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
        //     sortField: this.state.sortField,
        //     sortOrder: this.state[this.state.sortField + "sortOrder"],
        // }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/User/SelectAssignedDFSRiders", {
                userId: this.props.UserAuthentication.UserInfo.id
            }, (resp) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                if (resp.status) {
                   console.log(resp)
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.totalRecord
                    })
                }
                else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )

    }

    onDelete = (id, roleId) => {
        this.setState({
            alertModalData: {
                title: "Delete User",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => { $("#Generic-modal-CloseBtn").click(); this.DeleteRecord(id, roleId) },
                Second_Callback: () => { $("#Generic-modal-CloseBtn").click() },
                type: 1,
            }
        }, () => { $("#Show_ArletModal").click() })
    }

    DeleteRecord = (id, roleId) => {
        this.props.ShowLoader({ Isloading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Delete_User, { id: id, roleId: roleId },
            (Result) => {
                if (Result.status == true) {
                    if (roleId == 4) {
                        SyncConfig(() => {
                            this.PopulateTable()
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." })
                            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                        }, () => {
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({ Type: 0, Msg: "Error in sync, please reload the page" })
                            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                        })
                    }
                    else {
                        this.props.ShowLoader({ Isloading: false })
                        this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully" })
                        setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                        this.PopulateTable()
                    }
                }
                else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: Result.message })
                    setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(AssignedDFS_Riders);
